<template>
  <div>
    <div class="air__utils__heading">
      <h5>Class Recordings & Videos</h5>
    </div>
    <a-card>
      <a-alert type="info" message="Coming Soon" description="The interface to manage class recordings and uploaded videos will be implemented here." showIcon />
    </a-card>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
}
</script>
